<div class="container animated fadeIn consent-form">
  <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
    <div [innerHTML]="contentData()" ></div>
  </div>
</div>